
import { Base } from '../base-component';

import './infographic-page-bluebox.component.scss';

export class InfographicPageBluebox extends Base {

	constructor(element: Element){

		super(element)
				
	}

	init(){}
		
	bindEvents(){}

}




// WEBPACK FOOTER //
// ./components/infographic-page-bluebox/infographic-page-bluebox.component.ts